export default __webpack_public_path__ + "static/media/go.cda9e1cf.svg";